import { render, staticRenderFns } from "./ClientAndBranchInfo.vue?vue&type=template&id=871ef4bc"
import script from "./ClientAndBranchInfo.vue?vue&type=script&lang=js"
export * from "./ClientAndBranchInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports